export function currentMonthKey() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

// Shop points are a strict monthly allowance (see functions/index.js's
// creditShopPoints) — a profile's shopBalance only means anything if it was
// last touched in the current month; otherwise the real balance is 0.
export function getShopBalance(profile) {
  if (!profile) return 0;
  return profile.shopBalanceMonth === currentMonthKey() ? (profile.shopBalance || 0) : 0;
}

export function getEquippedItem(profile, shopItems, type) {
  const itemId = profile?.equipped?.[type];
  if (!itemId) return null;
  const item = shopItems.find((it) => it.id === itemId);
  return item && item.type === type ? item : null;
}
